import { render, staticRenderFns } from "./PayItForwardStatement.vue?vue&type=template&id=a3b33aac&v-if=isLoggedIn&"
import script from "./PayItForwardStatement.vue?vue&type=script&lang=js&"
export * from "./PayItForwardStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports